/**
 * @desc 导出toB企业订单税务报表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.customsClearance.exportCustomsClearanceDetailExcelReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/exportCustomsClearanceDetailExcelReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
